export default __webpack_public_path__ + "static/media/(28).7dcc8325.jpg";